import Challenge from 'junior/components/challenge/challenge';
<template><Challenge @challenge={{@model}} /></template>
